import { EntityType } from 'src/api'
import { TreeItemI } from '../CustomTree'

const getCheckedItems = (
  treeItems: TreeItemI[],
  options?: {
    entityType?: string
  }
) =>
  treeItems.reduce<TreeItemI[]>((acum, treeItem) => {
    if (treeItem.checked) {
      if (options?.entityType && treeItem.type !== options.entityType)
        return acum
      acum = [...acum, treeItem]
    }
    if (treeItem.treeItems != null) {
      acum = [...acum, ...getCheckedItems(treeItem.treeItems)]
    }
    return acum
  }, [])

const getUncheckedItems = (
  treeItems: TreeItemI[],
  options?: {
    entityType?: string
  }
) =>
  treeItems.reduce<TreeItemI[]>((acum, treeItem) => {
    if (!treeItem.checked && !treeItem.indeterminate) {
      if (options?.entityType && treeItem.type !== options.entityType)
        return acum
      acum = [...acum, treeItem]
    }
    if (treeItem.treeItems != null) {
      acum = [...acum, ...getUncheckedItems(treeItem.treeItems)]
    }
    return acum
  }, [])

const checkAll = (treeItems: TreeItemI[], value: boolean): TreeItemI[] =>
  treeItems.map((treeItem) => {
    if (treeItem.treeItems?.length) {
      return {
        ...treeItem,
        checked: value,
        treeItems: checkAll(treeItem.treeItems, value)
      }
    }
    return {
      ...treeItem,
      checked: value
    }
  })

const updateTreeItems = (
  id: string,
  type: EntityType | undefined,
  value: boolean,
  treeItems: TreeItemI[]
): TreeItemI[] => {
  return treeItems.map((treeItem) => {
    if (
      treeItem.id === id &&
      treeItem.type === type &&
      treeItem.checked !== value
    ) {
      if (treeItem.treeItems?.length) {
        return {
          ...treeItem,
          checked: value,
          treeItems: checkAll(treeItem.treeItems, value)
        }
      }
      return {
        ...treeItem,
        checked: value
      }
    }
    if (treeItem.treeItems?.length) {
      return {
        ...treeItem,
        treeItems: updateTreeItems(id, type, value, treeItem.treeItems)
      }
    }
    return treeItem
  })
}

const updateTreeItemsByChildrensCheck = (treeItems: TreeItemI[]): TreeItemI[] =>
  treeItems.map((treeItem) => {
    if (treeItem.treeItems?.length) {
      const newTreeItems: TreeItemI[] = updateTreeItemsByChildrensCheck(
        treeItem.treeItems
      )
      const someTreeItemIsUncheck = checkSomeTreeItemIsUncheck(newTreeItems)
      return {
        ...treeItem,
        checked: !someTreeItemIsUncheck,
        treeItems: updateTreeItemsByChildrensCheck(newTreeItems),
        indeterminate: checkSomeTreeItemIsCheck(newTreeItems)
      }
    }
    return treeItem
  })

const checkSomeTreeItemIsUncheck = (treeItems: TreeItemI[]): boolean =>
  treeItems.some((treeItem) => {
    if (!treeItem.checked) return true
    if (treeItem.treeItems?.length) {
      return checkSomeTreeItemIsUncheck(treeItem.treeItems)
    }
    return false
  })

const checkSomeTreeItemIsCheck = (treeItems: TreeItemI[]): boolean =>
  treeItems.some((treeItem) => {
    if (treeItem.checked) return true
    if (treeItem.treeItems?.length) {
      return checkSomeTreeItemIsCheck(treeItem.treeItems)
    }
    return false
  })

export const customTreeUtils = {
  getCheckedItems,
  getUncheckedItems,
  updateTreeItems,
  checkAll,
  updateTreeItemsByChildrensCheck,
  checkSomeTreeItemIsUncheck,
  checkSomeTreeItemIsCheck
}
